export const env = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    zoomSDKKey: process.env.REACT_APP_ZOOM_SDK_KEY,
    auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN,
    auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    idealLogoutMinutes: process.env.REACT_APP_IDEL_LOGOUT_MINUTES,
}

export const MAX_FILES = 5;
export const MAX_SIZE_MB = 25;